<template>
  <main role="main" class="main bg-navy">
    <profile-menu-mobile></profile-menu-mobile>
    <search-filter-mobile :search="search"></search-filter-mobile>
    <div class="mobile-vh min-h-100 p-4 p-md-5 bg-light-grey mobi-rounded-top">
      <profile-menu></profile-menu>
      <b-row>
        <b-col md="11" offset-md="1">
          <search-filter :search="search"></search-filter>
          <b-row>
            <b-col cols="12" md="3" class="mb-2 mb-md-0">
              Date range:
              <strong v-if="search.records && search.records >= 10">Last {{ search.records }} Records</strong>
              <strong v-else>{{ search.dateFrom | moment('MMM Do YYYY') }} - {{ search.dateTo | moment('MMM Do YYYY') }}</strong>
            </b-col>
            <b-col cols="12" md="3" class="mb-2 mb-md-0">
              Payment Types: <strong>
                <span v-if="search.types.credit">Credit</span>
                <span v-if="search.types.credit && search.types.debit"> / </span>
                <span v-if="search.types.debit">Debit</span>
              </strong>
            </b-col>
            <b-col cols="12" md="6" class="mb-3 mb-md-0">
              Currency:
              <strong v-for="(currency, $index) in search.currencies" :key="$index">
                <div class="flag ml-1" :class="'flag-' + availableCurrencies.find(_currency => _currency.id === currency).flag"></div>
                {{ currency === 'ZARUK' ? 'ZAR (Offshore)' : (currency === 'ZAR' ? 'ZAR (Onshore)' : currency) }}
                <span v-if="$index + 1 < search.currencies.length"> / </span>
              </strong>
            </b-col>
          </b-row>
          <statement :records="loadStatus === 'loaded' ? filteredList : []" v-on:refresh="refresh"></statement>
        </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
import ProfileMenu from '@/components/global/ProfileMenu'
import ProfileMenuMobile from '@/components/global/ProfileMenuMobile'
import SearchFilter from '@/components/payments/SearchFilter'
import SearchFilterMobile from '@/components/payments/SearchFilterMobile'
import Statement from '@/components/payments/Statement'
// import { isMobile } from 'mobile-device-detect'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

function addDays (date, days) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export default {
  components: {
    ProfileMenu,
    ProfileMenuMobile,
    SearchFilter,
    Statement,
    SearchFilterMobile
  },
  data () {
    return {
      search: {
        term: null,
        types: {
          eft: true,
          instanteft: true,
          card: true,
          wallet: true,
          debit: true,
          credit: true
        },
        ledgers: {
          transactions: true,
          wallet: true,
          fees: true
        },
        period: null,
        records: 10,
        currency: 'ZAR',
        currencies: [],
        dateFrom: new Date(new Date().setHours(0, 0, 0)),
        dateTo: new Date(new Date().setHours(23, 59, 59))
      }
    }
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      currencies: state => state.currency.currencies,
      list: state => state.statement,
      auth: (state) => state.auth,
      company: (state) => state.company,
      userStore: (state) => state.user
    }),
    availableCurrencies () {
      const _currencies = []
      this.currencies.forEach((_currency) => {
        if (_currency.id === 'ZAR') {
          _currencies.push(_currency)
        } else if (_currency.fx) {
          if (this.auth && this.auth.user && this.auth.user.user && this.user) {
            if (this.auth.user.user.company) {
              if (this.company.company) {
                const _funds = this.company.company.funds.foreign.find(
                  (fund) => fund.currency === _currency.id
                )
                if (_funds) {
                  _currencies.push(_currency)
                }
              }
            } else {
              const _funds = this.user.funds.foreign.find(
                (fund) => fund.currency === _currency.id
              )
              if (_funds) {
                _currencies.push(_currency)
              }
            }
          }
        }
      })

      return _currencies
    },
    user () {
      return this.userStore ? this.userStore.user : null
    },
    loadStatus () {
      return this.list.status
    },
    nameFilter () {
      if (this.search.term && this.search.term.length > 0) {
        const self = this
        return this.list.statement.filter(function (transaction) {
          let _return = transaction.reference.indexOf(self.search.term) >= 0

          if (transaction.sender && transaction.sender.personal) {
            _return = _return || transaction.sender.personal.first_names.indexOf(self.search.term) >= 0 || transaction.sender.personal.surname.indexOf(self.search.term) >= 0
          }

          if (transaction.sender_company) {
            _return = _return || transaction.sender_company.name.indexOf(self.search.term) >= 0
          }

          if (transaction.recipient && transaction.recipient.personal) {
            _return = _return || transaction.recipient.personal.first_names.indexOf(self.search.term) >= 0 || transaction.recipient.personal.surname.indexOf(self.search.term) >= 0
          }

          if (transaction.recipient_company) {
            _return = _return || transaction.recipient_company.name.indexOf(self.search.term) >= 0
          }

          return _return
        })
      } else {
        return this.list.statement
      }
    },
    typeFilter () {
      if (this.nameFilter) {
        const _types = this.search.types
        const _ledgers = this.search.ledgers
        return this.nameFilter.filter(function (transaction) {
          let _type = false
          let _method = false
          let _ledger = false

          if (transaction.payment_type === 'Credit') {
            _type = _types.credit
          } else if (transaction.payment_type === 'Debit') {
            _type = _types.debit
          }

          if (transaction.payment_method === 'EFT') {
            _method = _types.eft
          } else if (transaction.payment_method === 'InstantEFT') {
            _method = _types.instanteft
          } else if (transaction.payment_method === 'Card' || transaction.payment_method === 'Credit Card') {
            _method = _types.card
          } else if (transaction.payment_method === 'Wallet') {
            _method = _types.wallet
          } else if (transaction.payment_method === 'Truzo') {
            _method = true
          }

          if (transaction.ledger === 'Transactions') {
            _ledger = _ledgers.transactions
          } else if (transaction.ledger === 'Wallet') {
            _ledger = _ledgers.wallet
          } else if (transaction.ledger === 'Truzo Fees') {
            _ledger = _ledgers.fees
          }

          return _type && _method && _ledger
        })
      } else {
        return this.nameFilter
      }
    },
    filteredList () {
      return this.typeFilter.filter(_record => _record.amount !== 0)
    },
    selectedCurrency () {
      return this.currencies.find(_currency => _currency.id === this.search.currency)
    }
  },
  methods: {
    ...mapActions('alert', {
      setError: 'error'
    }),
    ...mapActions('statement', {
      getDated: 'getDated',
      getRecords: 'getRecords'
    }),
    refresh: function () {
      this.$bvModal.show('loading')
      if (this.search.records && this.search.records >= 10) {
        this.getRecords({ currency: this.search.currencies.join(','), records: this.search.records, noFx: true, authorizations: true })
      } else {
        this.getDated({ currency: this.search.currencies.join(','), dateFrom: this.search.dateFrom, dateTo: this.search.dateTo, noFx: true, authorizations: true })
      }
    }
  },
  created () {
    this.availableCurrencies.forEach(_currency => {
      this.search.currencies.push(_currency.id)
    })

    this.refresh()
  },
  watch: {
    loadStatus (_new, _old) {
      if (_new && this.alert.type !== 'alert-danger') {
        if (_new !== 'loading') {
          this.$bvModal.hide('loading')
        }
      }
    },
    'search.period': function (value) {
      if (value === 'yesterday') {
        this.search.records = null
        this.search.dateFrom = new Date(moment().subtract(1, 'days').startOf('day').toString())
        this.search.dateTo = new Date(moment().subtract(1, 'days').endOf('day').toString())
      } else if (value === 'thisweek') {
        this.search.records = null
        this.search.dateFrom = new Date(moment().startOf('week').startOf('day').toString())
        this.search.dateTo = new Date(moment().endOf('day').toString())
      } else if (value === 'lastweek') {
        this.search.records = null
        this.search.dateFrom = new Date(moment().subtract(1, 'week').startOf('week').startOf('day').toString())
        this.search.dateTo = new Date(moment().subtract(1, 'week').endOf('week').endOf('day').toString())
      } else if (value === 'thismonth') {
        this.search.records = null
        this.search.dateFrom = new Date(moment().startOf('month').startOf('day').toString())
        this.search.dateTo = new Date(moment().endOf('day').toString())
      } else if (value === 'lastmonth') {
        this.search.records = null
        this.search.dateFrom = new Date(moment().subtract(1, 'month').startOf('month').startOf('day').toString())
        this.search.dateTo = new Date(moment().subtract(1, 'month').endOf('month').endOf('day').toString())
      } else if (value === 'today') {
        this.search.records = null
        this.search.dateFrom = new Date(new Date().setHours(0, 0, 0))
        this.search.dateTo = new Date(new Date().setHours(23, 59, 59))
      } else {
        this.search.dateFrom = null
        this.search.dateTo = null
      }

      this.refresh()
    },
    'search.dateFrom': function () {
      if (this.search.dateTo > addDays(this.search.dateFrom, 31) && this.search.period === 'custom') {
        this.search.dateTo = addDays(this.search.dateFrom, 31)
      }
    },
    'search.dateTo': function (date) {
      if (this.search.period === 'custom') {
        const _time = date.getTime() - this.search.dateFrom.getTime()
        if (_time / (1000 * 3600 * 24) <= 31) {
          this.search.records = null
          this.refresh()
        } else {
          this.setError('Period selected is over 31 days! Please, select a smaller period and try again.')
        }
      }
    },
    'search.records': function () {
      if (this.search.records && this.search.records >= 10) {
        this.search.period = null
        this.search.dateFrom = null
        this.search.dateTo = null
      }

      this.refresh()
    },
    'search.currencies': function () {
      this.refresh()
    }
  }
}
</script>
